/**
 * Default due time for review forms (5:00 PM / 17:00 in 24-hour format)
 * Used for:
 * - DatePicker defaultTime prop
 * - Date conversion calculations between relative and static dates
 */
export const DEFAULT_DUE_TIME = 17;
